import { render } from "./BlocksRenderer.vue?vue&type=template&id=6c77f831"
import script from "./BlocksRenderer.vue?vue&type=script&lang=js"
export * from "./BlocksRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__